import React from 'react';
import { Box, Heading, Text, Button, Image, HStack, Badge } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FiClock, FiUser } from 'react-icons/fi';
import {useAppData} from '../../store/dataStore';

const MotionBox = motion(Box);

const BlogFeatured = () => {
  const { appData } = useAppData();
  const { studentsCount } = appData;
  return (
    <Box maxW="1200px" mx="auto" px={{ base: 4, md: 8 }} py={12}>
      <MotionBox
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        bg="white"
        borderRadius="2xl"
        overflow="hidden"
        boxShadow="lg"
        _hover={{ transform: 'translateY(-4px)', boxShadow: 'xl', transition:"all 0.3s" }}
        
      >
        <Box display={{ base: 'block', md: 'flex' }}>
          <Box w={{ base: '100%', md: '50%' }}>
            <Image
              src="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800"
              alt="Featured article"
              h={{ base: '250px', md: 'full' }}
              w="full"
              objectFit="cover"
            />
          </Box>
          <Box w={{ base: '100%', md: '50%' }} p={8}>
            <Badge colorScheme="green" mb={3}>Featured</Badge>
            <Heading as="h2" size="xl" mb={4} color="brand.800" fontFamily="heading">
              How Will AI Affect the Global Workforce in 2025?
            </Heading>
            <Text color="brand.500" mb={4}>
              Explore the transformative impact of AI on jobs and skills.
            </Text>
            <HStack spacing={4} mb={4} color="brand.400" fontSize="sm">
              <HStack>
                <FiUser />
                <Text>Sarah Chen</Text>
              </HStack>
              <HStack>
                <FiClock />
                <Text>5 min read</Text>
              </HStack>
            </HStack>
            <Button variant="solid" size="lg">
              Read More
              {/* GA: blog_view */}
            </Button>
          </Box>
        </Box>
      </MotionBox>
    </Box>
  );
};

export default BlogFeatured;
